export default {
    data() {
        return {
            dark: this.getThemeFromLocalStorage(),
        };
    },
    // created() {
    //     console.log('created component');
    //     console.log('Dark theme:' + this.dark);
    // },
    methods: {
        setTheme(value) {
            const el = document.getElementsByTagName('html')[0];
            if (value) {
                el.classList.add('dark');
            } else {
                el.classList.remove('dark');
            }
        },
        getThemeFromLocalStorage() {
            let darkValue;
            // if user already changed the theme, use it
            if (window.localStorage.getItem('dark')) {
                darkValue = JSON.parse(window.localStorage.getItem('dark'));
            } else {
                // else return their preferences
                darkValue = (
                    !!window.matchMedia &&
                    window.matchMedia('(prefers-color-scheme: dark)').matches
                );
            }
            this.setTheme(darkValue);
            return darkValue;
        },
        setThemeToLocalStorage(value) {
            window.localStorage.setItem('dark', value);
            this.setTheme(value);
        },
        deleteThemeFromLocalStorage() {
            window.localStorage.removeItem('dark')
        },
        can(permissionName, tenantId = null, targetType = null, targetId = null) {
            return this.$page.props.allUserPermissions
                && this.$page.props.allUserPermissions.filter((permission) =>
                    permission.name === permissionName
                    && permission.tenantId === tenantId
                    && permission.targetType === targetType
                    && permission.targetId === targetId
                )?.length;
        },
        canAny(permissionsArray, tenantId = null, targetType = null, targetId = null) {
            if (!Array.isArray(permissionsArray)) {
                return this.can(permissionsArray, tenantId, targetType, targetId)
            }
            for (const permission of permissionsArray) {
                // console.log(permission)
                if (this.$page.props.allUserPermissions
                    && this.can(permissionsArray, tenantId, targetType, targetId)) {
                    return true;
                }
            }
            return false;
        },
        route
    }
};
